<template>
  <v-card class="py-3 item" color="transparent" :to="to" flat tile>
    <img
      @error="imgError"
      class="d-block rounded-circle item-img"
      :src="files + img + '?resize=1&w=400'"
      :alt="title"
      width="100%"
      height="100%"
    />

    <div
      class="
        white--text
        text-body-1 text-md-h6 text-center
        font-weight-medium
        px-3
        mt-3 mt-md-4
      "
    >
      {{ title }}
    </div>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    imgError(e) {
      e.target.src = DefaultImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 1;
    border: 3px solid transparent;
    object-fit: cover;
    transition: all 0.1s linear;
  }

  &:hover {
    .item-img {
      border: 3px solid var(--v-secondary-base);
    }
  }
}
</style>
